const _ = require('lodash');

/**
 * A component to display related products in a link list
 *
 * The data is stored in the application text as an array of arrays of objects
 *
 * "related_products": [
 *   [{id: 123, name: 'Not used'}, {id: 345, name: 'Helpful name'}]
 * ];
 *
 * The name in the above object is only there to make it easy to know which products were linked.
 * The name that displays in the UI comes from the name defined in the admin
 */
const RelatedProducts = function (app) {
  const configure = app.configure;
  const label = app.l10n.getLang('related_products_label', 'Also Availabe:');
  // Related product data stored in application text
  const relatedProducts = app.l10n.getLang('related_products');

  function init() {
    const currentId = app.product.id;

    if (!relatedProducts) {
      return;
    }

    // Looping over the array of arrays
    relatedProducts.forEach(productSet => {
      // Check to see if the current Product ID is defined in the
      // relatedProducts data
      const hasRelated = _.findIndex(productSet, { id: currentId });

      if (hasRelated >= 0) {
        configure.run('getCustomerReport', (err, report) => {
          if (err) { console.error(err); }

          // Remove the current Product ID from the product set
          productSet.splice(hasRelated, 1);

          // Create an array of product data objects
          const relatedProducts = productSet.map(product => {
            const match = _.find(report.productDetails, { id: product.id });
            // The name object comes back with multiple locales defined
            // replace it with the currently defined locale
            match.name = match.name[app.mergedParams.locale];

            // Add the URL's from the application text product
            match.externalUrl = product.urls;

            return match;
          });

          // I miss JSX
          let markup = `<p>${label}</p>`;

          relatedProducts.forEach(product => {
            // Construct a URL, if internal swap out the product ID
            // if external we use the external data based on the workflow
            const url = (app.isFluidEnv()) ?
              app.utils.updateUrlParameter(location.href, 'product', product.id) :
              product.externalUrl[app.mergedParams.workflow];
            // Note: At the time of development they do not want a new tab or window
            markup += `<a href="${url}">${product.name}</a>`;
          });

          // Update the DOM with our links
          document.querySelector('.fc-related-products-container').innerHTML = markup;
        });
      }
    });
  }

  return {
    init
  };
};

module.exports = RelatedProducts;
